export const transportationTag = [
  'transportationByIdForEdit',
  'transport_invoiceByCompanyId',
  'transport_ModifyAdd',
  'master_transport_comp',
  'master_locations',
  'master_forwarders',
  'master_forwarders_charges',
] as const;
